import React from "react";
import { TextField, Box } from "@mui/material";
import { getFieldLabel } from "../../constants/Helpers";
import HelpText from "../../components/HelpText/HelpText";

function LobsterForm(props) {
  return (
    <Box display="flex" flexDirection={"column"} justifyContent="center">
      <Box m={0} width="100%" align="center">
        <h2 className="sectionTitle center">
          {getFieldLabel("trip", "trapsInWater")}
        </h2>
        <TextField
          name="trapsInWater"
          variant="standard"
          inputProps={{
            min: 1,
            style: { textAlign: "center" },
          }}
          size="small"
          type="number"
          value={props.trapsInWater}
          onChange={props.handleInputChange}
        />
        <HelpText
          helpText={getFieldLabel("trip", "trapsInWater", "helptext")}
        />
      </Box>
      <Box m={0} width="100%" align="center">
        <h2 className="sectionTitle center">
          {getFieldLabel("trip", "trapsPerString")}
        </h2>
        <TextField
          name="trapsPerString"
          variant="standard"
          inputProps={{
            min: 1,
            style: { textAlign: "center" },
          }}
          size="small"
          type="number"
          value={props.trapsPerString}
          onChange={props.handleInputChange}
        />
        <HelpText
          helpText={getFieldLabel("trip", "trapsPerString", "helptext")}
        />
      </Box>
      <Box mt={0} width="100%" align="center">
        <h2 className="sectionTitle center">
          {getFieldLabel("trip", "totNrBuoyLines")}
        </h2>
        <TextField
          name="buoyLines"
          variant="standard"
          inputProps={{
            min: 1,
            style: { textAlign: "center" },
          }}
          size="small"
          type="number"
          value={props.buoyLines}
          onChange={props.handleInputChange}
        />
        <HelpText
          helpText={getFieldLabel("trip", "totNrBuoyLines", "helptext")}
        />
      </Box>
    </Box>
  );
}

export default LobsterForm;
